import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LoadingService } from '../../../../shared/services/loading.service';
import { NewInspectionService } from '../../services/new-inspection.service';
import { ActivatedRoute } from '@angular/router';
import { SystemInspectionDetailView, ComponentOnSystemInspectionViewModel } from '../../models/create-inspection.model';
import { AppService } from '../../../../app.service';
import { CustomeEvaluationRangeVM } from '../../../../modules/CustomEval/custom-eval.model';
import { toolType } from '../../../../shared/enums/allEnums';

@Component({
  selector: 'app-inspection-review',
  templateUrl: './inspection-review.component.html',
  styleUrls: ['./inspection-review.component.scss']
})
export class InspectionReviewComponent implements OnInit {
  @Input() inspectionDraftId: number = -1;
  oldInspectionId: number;
  @Input() side: number  = -1;
  @Input() systemType: number = -1;
  @Input() EvalautionRange:CustomeEvaluationRangeVM;
  @Input() totalInspDistance: number = 0;

  @Input() system: SystemInspectionDetailView;
  equipmentId: number;
  loadingSystems: boolean;
  toolType = toolType;

  constructor(
    private _sanitizer: DomSanitizer,
    private _loading: LoadingService,
    private _newInspectionService: NewInspectionService,
    private _appSerivce: AppService,
    private route: ActivatedRoute) { }

  ngOnInit() {

    this.equipmentId = +this.route.snapshot.paramMap.get('id');
    this.oldInspectionId = +this.route.snapshot.paramMap.get('id2');
    console.log(" systemchildreview",this.system);
    //this.loadSystem();
  }

  GetEvalColour(comp: ComponentOnSystemInspectionViewModel, worn: number) {
    var compType = comp.CompartTypeId;

    if(comp.ToolId === toolType.Eval){
      if(comp.EvalCode == '')
       return 'Eval-U';
      else
        return 'Eval-' + comp.EvalCode;
    }
  if (comp.MeasurementReading === -1 || comp.ToolId === toolType.YESorNO || comp.ToolId === toolType.PassorFail) {
    return 'Eval-U';
  }
    switch (compType) {
      case 230: //Link
        if (this.EvalautionRange.LinkC != null) {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.LinkC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

        case 231://Bush
          if (this.EvalautionRange.BushC != null) {
            if (worn <= this.EvalautionRange.BushA)
              return 'Eval-A';
            else if (worn <= this.EvalautionRange.BushB)
              return 'Eval-B';
            else if (worn <= this.EvalautionRange.BushC)
              return 'Eval-C';
            else
              return 'Eval-X';
          } else {
            if (worn <= this.EvalautionRange.BushA)
              return 'Eval-A';
            else if (worn <= this.EvalautionRange.BushB)
              return 'Eval-B';
            else
              return 'Eval-X';
          }
        
          case 232: //Shoe
            if (this.EvalautionRange.ShoeC != null) {
              if (worn <= this.EvalautionRange.ShoeA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.ShoeB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.ShoeC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.ShoeA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.ShoeB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }

            case 233://Idler
            if (this.EvalautionRange.LinkC != null) {
              if (worn <= this.EvalautionRange.LinkA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.LinkB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.LinkC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.LinkA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.LinkB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }

            case 234://carrier Roller
            if (this.EvalautionRange.CarrierRollerC != null) {
              if (worn <= this.EvalautionRange.CarrierRollerA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.CarrierRollerB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.CarrierRollerC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.CarrierRollerA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.CarrierRollerB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }

            case 235://track Roller
            if (this.EvalautionRange.TrackRollerC != null) {
              if (worn <= this.EvalautionRange.TrackRollerA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.TrackRollerB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.TrackRollerC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.TrackRollerA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.TrackRollerB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }
            case 236://Sprokcket
            if (this.EvalautionRange.SprocketC != null) {
              if (worn <= this.EvalautionRange.SprocketA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.SprocketB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.SprocketC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.SprocketA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.SprocketB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }

            case 240://Elognation
            if (this.EvalautionRange.ElongationC != null) {
              if (worn <= this.EvalautionRange.ElongationA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.ElongationB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.ElongationC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.ElongationA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.ElongationB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }

            case 417://Crawler
            if (this.EvalautionRange.CrawlerGuideC != null) {
              if (worn <= this.EvalautionRange.CrawlerGuideA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.CrawlerGuideB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.CrawlerGuideC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.CrawlerGuideA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.CrawlerGuideB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }

            case 446://RSREAR
            if (this.EvalautionRange.RSRearIdlerC != null) {
              if (worn <= this.EvalautionRange.RSRearIdlerA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.RSRearIdlerB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.RSRearIdlerC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.RSRearIdlerA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.RSRearIdlerB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }

            case 237://GUARD
         
              if (worn <= 30)
                return 'Eval-A';
              else if (worn <= 50)
                return 'Eval-B';
              else if (worn <= 70)
                return 'Eval-C';
              else
                return 'Eval-X';
            
      default:
        break;
    }
  }
  loadSystem() {

    if (this.oldInspectionId !==   this.inspectionDraftId && this.inspectionDraftId !== -1 && this.inspectionDraftId !== undefined && this.inspectionDraftId !== undefined) {
      this._loading.startLoading();
      this._newInspectionService.getSystemView(this.equipmentId, this.inspectionDraftId, this.side, this.systemType, 0, 0, this.totalInspDistance).subscribe(s => {
        this.system = s;
        this._loading.finishedLoading();
        this.loadingSystems = false;
        this.inspectionDraftId = s.InspectionDraftId;
     });
    }

  }

  sanitize(image: string, isImageUrl: boolean ) {
    if (!isImageUrl)
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
    else 
      return image;
  }

  getImage(image: string) {
    if (image != null && image !== undefined)
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }
  getComponent(componentId: number): ComponentOnSystemInspectionViewModel {
    return this.system.Components.find(c => c.GeneralEqUnitId === componentId);
  }

  getChildRowPosition(componentId: number): string {
    const component = this.getComponent(componentId);
    const children = this.system.Components.filter(c => c.CompartTypeId === component.CompartTypeId && c.IsChild);
    if (children[0].GeneralEqUnitId === componentId) return '--extended';
    if (children[children.length - 1].GeneralEqUnitId === componentId) return '--half';
    return '';
  }


  showPosition(position: number, compartTypeId: number): string {

    let hasSameComponent = this.system.Components.filter(x=>x.CompartTypeId==compartTypeId && x.IsChild==false);
    if(hasSameComponent.length>1){
      return this.getPositionStringDoubleComponents(position,compartTypeId);
    }else{
      return this._appSerivce.getPositionString(position, compartTypeId);
    }
   
}

getPositionStringDoubleComponents(Pos: number, CompartTypeId: number): string {
  if (CompartTypeId === 233) // Idler
      if (Pos === 1) return 'Front'; else if (Pos === 2) return 'Rear';
  if (CompartTypeId === 234 && Pos === 1) // Carrier roller
      return 'Front';
  if (CompartTypeId >= 230 && CompartTypeId <= 232 || CompartTypeId === 236 || CompartTypeId === 237 || CompartTypeId === 240 || Pos === undefined)
  {// Link, Bushing, Shoe, Sprocket
      if (Pos === 1) return 'Front'; else if (Pos === 2) return 'Rear';
     
  } 
  if(CompartTypeId == 446)
      return 'Rear'
  return Pos.toString();
}
}
